module.exports = __webpack_public_path__ + "static/media/AB_lock_red.872df644.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_lock_red.svg
// module id = 254
// module chunks = 0